import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const details = {
      transactionId: params.get('transactionId') || 'TXN' + Date.now(),
      amount: params.get('amount') || '0',
      planName: params.get('planName') || 'Premium Plan',
      members: params.get('members') || '1',
      billingCycle: params.get('billingCycle') || 'monthly'
    };
    setPaymentDetails(details);
  }, [location]);

  const handleContinue = () => {
    navigate('/dashboard');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#4caf50',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px'
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
        </div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          color: '#4caf50',
          marginBottom: '16px'
        }}>
          Payment Successful! 🎉
        </h1>

        <p style={{
          fontSize: '1.2rem',
          color: '#666',
          marginBottom: '30px'
        }}>
          Your subscription has been activated successfully!
        </p>

        {paymentDetails && (
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Payment Details</h3>
            
            <div style={{ display: 'grid', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Transaction ID:</span>
                <span style={{ fontWeight: '600' }}>{paymentDetails.transactionId}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Plan:</span>
                <span style={{ fontWeight: '600' }}>{decodeURIComponent(paymentDetails.planName)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Members:</span>
                <span style={{ fontWeight: '600' }}>{paymentDetails.members}</span>
              </div>
              <hr />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' }}>
                <span style={{ fontWeight: '600' }}>Total Amount:</span>
                <span style={{ fontWeight: '700', color: '#4caf50' }}>₹{paymentDetails.amount}</span>
              </div>
            </div>
          </div>
        )}

        <div style={{
          backgroundColor: '#e8f5e8',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '30px'
        }}>
          <p style={{ margin: '0', color: '#2e7d32', fontSize: '0.95rem' }}>
            📧 A confirmation email has been sent to your registered email address.
          </p>
        </div>

        <button
          onClick={handleContinue}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#4caf50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer'
          }}
        >
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;